import React from 'react';
import { Box, Link, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useHistory } from 'react-router-dom';
import key from '../../routes/key';

export interface AdditionalResultLinksProps {
  eligibleForResit?: boolean;
  eligibleForAppeal?: boolean;
}

const useStyles = makeStyles()((theme) =>
({
  tableCaption: {
    paddingTop: theme.spacing(2)
  },
  typography:{
    display: 'inline'
  }
}));

const AdditionalResultLinks = ({
  eligibleForResit = false,
  eligibleForAppeal = false
}: AdditionalResultLinksProps) => {
  const { resit, appeal } = key.child;
  const { instruction } = key.resit.child;
  const { importantNotes, applications } = key.appeal.child;
  const { classes } = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <>
      {eligibleForResit && (
        <Box className={classes.tableCaption}>
          <Typography className={classes.typography} variant="caption">
            {t('exam->>ResultDetail.If you wish to resit your Mother Tongue subject, please ')}
          </Typography>
          <Link onClick={() => history.push(`/${resit}/${instruction.route}`)}>
            <Typography className={classes.typography} variant="caption">{t('exam->>ResultDetail.click here.')}</Typography>
          </Link>
        </Box>
      )}
      {eligibleForAppeal && (
        <Box className={classes.tableCaption}>
          <Typography className={classes.typography} variant="caption">{t('exam->>ResultDetail.Appeal')}</Typography>
          <Link
            onClick={() => history.push(`/${appeal}/${applications.route}/${importantNotes.route}`)}
          >
            <Typography className={classes.typography} variant="caption">{t('exam->>ResultDetail.click here.')}</Typography>
          </Link>
        </Box>
      )}
    </>
  );
};

export default AdditionalResultLinks;
